import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5cf8b272&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5cf8b272&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf8b272",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cf8b272')) {
      api.createRecord('5cf8b272', component.options)
    } else {
      api.reload('5cf8b272', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5cf8b272&scoped=true", function () {
      api.rerender('5cf8b272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/enterpriseDistribution/bindDeviceRecord/index.vue"
export default component.exports